module.exports = __webpack_public_path__ + "static/img/img_2.64b0d439.jpg";